import { ColumnFilter } from '../Grid'
import './Filter.scss'

interface FilterProps<T> {
  columnKey: string
  filters: Record<string, ColumnFilter<T> | undefined>
  placeholder?: string
  onChange: (key: string, filter: ColumnFilter<T>) => void
  onModalOpen: (key: string) => void
  pending?: boolean
}
export function Filter<T>(props: FilterProps<T>) {
  const filter = props.filters[props.columnKey]
  const value = filter?.format?.(filter.value as never) ?? filter?.value?.toString() ?? ''

  const handleClearClick = () => {
    if (filter) {
      props.onChange(props.columnKey, { ...filter, value: undefined })
      const cascadeClearKeys =
        typeof filter.cascadeClear === 'string' ? [filter.cascadeClear] : [...(filter.cascadeClear ?? [])]
      for (const cascadeClearKey of cascadeClearKeys) {
        const cascadeClearFilter = props.filters[cascadeClearKey]
        if (!cascadeClearFilter || cascadeClearFilter.readOnly) {
          continue
        }
        props.onChange(cascadeClearKey, { ...cascadeClearFilter, value: undefined })
      }
    }
  }

  if (filter?.type === 'inline_selector_filter') {
    return (
      <div className="grid-filter">
        <div className="selectArea">
          <select
            value={filter.value || ''}
            style={{ padding: '6px 25px 5px 5px' }}
            onChange={(e) =>
              !filter.readOnly && props.onChange(props.columnKey, { ...filter, value: e.target.value || undefined })
            }
            onClick={(e) => e.stopPropagation()}
          >
            {filter.enableAllOption && (
              <option key={'none'} value={''}>
                All
              </option>
            )}
            {filter.data?.map((value, i) => (
              <option key={i} value={value}>
                {filter.format?.(value) ?? value}
              </option>
            ))}
          </select>
          <i className="icon-bottom" />
        </div>
      </div>
    )
  } else if (filter?.type === 'inline_button_filter') {
    const state = filter.value ? filter.conditionals?.on : filter.conditionals?.off
    const cndBtnText = state?.text ?? ''
    const cndIcon = state?.icon
    const cndClass = state?.class
    return (
      <div className="grid-filter">
        <button
          onClick={() => props.onChange(props.columnKey, { ...filter, value: !filter.value })}
          className={` ${cndClass ?? ''}`}
        >
          {cndIcon && !filter.conditionals?.renderRight && <span className={cndIcon}></span>}
          {filter.icon && <span className={filter.icon}></span>}
          {cndBtnText} {filter.btnText}
          {cndIcon && filter.conditionals?.renderRight && <span className={cndIcon}></span>}
        </button>
      </div>
    )
  } else if (filter) {
    return (
      <div className="grid-filter">
        <input
          className={value ? 'filled' : 'empty'}
          onClick={(e) => {
            e.stopPropagation()
            return filter.type.startsWith('modal') && !filter.readOnly && props.onModalOpen(props.columnKey)
          }}
          placeholder={filter.customPlaceholder ? filter.customPlaceholder : props.placeholder}
          value={value}
          type="text"
          onChange={(e) =>
            filter.type === 'inline_text_filter' &&
            !filter.readOnly &&
            props.onChange(props.columnKey, { ...filter, value: e.target.value || undefined })
          }
        />
        {!!value && !filter.readOnly && <i onClick={handleClearClick} className="icon-clear" />}
        {filter.debounce && props.pending && <div className="grid-header-filter-loader" />}
      </div>
    )
  } else {
    return null
  }
}
